<template>
<div class='members'>
  <el-tabs class='content' theme='info' :value="canDo('view_members') ? 'details' : 'logs'">
    <el-tab-pane label="成员信息" name="details" v-if="canDo('view_members')">
      <details-card />
    </el-tab-pane>
    <el-tab-pane label="操作日志" name="logs">
      <logs-card />
    </el-tab-pane>
    <el-tab-pane label="权限管理" name="permissions" v-if="canDo('edit_members') && !tbcMode">
      <permissions-card />
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<style lang='scss' scoped>
.content {
    width: $page-width-small;
    min-height: $min-height-base;
    background-color: $color-white-base;
    margin: $margin-base auto 0;
    box-shadow: $box-shadow-base;
    padding: $margin-base;
}
</style>

<script>
import Details from './details/'
import Logs from './logs/'
import Permissions from './permissions/'

export default {
  components: {
    'details-card': Details,
    'logs-card': Logs,
    'permissions-card': Permissions
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?22cb94c6